<div class="card-header py-3">
    <h6 class="m-0 font-weight-bold text-primary">{{ 'ticket-in-category-stats' | translate}}</h6>
</div>
<div class="card-body">
    <mat-form-field>
        <mat-label>{{ 'category' | translate }}</mat-label>
        <mat-select matNativeControl [(ngModel)]="selectedCategoryId" (selectionChange)="changeCategory()">
            <mat-option *ngFor="let category of categories" [value]="category.id">
                {{ category.fullName | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="processedCategoryTicketsCounts[selectedCategoryId]">
        <h4 class="small font-weight-bold">{{ 'accepted' | translate }}
            <span class="float-right">{{ processedCategoryTicketsCounts[selectedCategoryId].acceptedTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-success" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedCategoryTicketsCounts[selectedCategoryId].acceptedTicketsCount"
                [style.width]="(processedCategoryTicketsCounts[selectedCategoryId].acceptedTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
        <h4 class="small font-weight-bold">{{ 'redirected' | translate }}
            <span class="float-right">{{ processedCategoryTicketsCounts[selectedCategoryId].redirectedTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedCategoryTicketsCounts[selectedCategoryId].redirectedTicketsCount"
                [style.width]="(processedCategoryTicketsCounts[selectedCategoryId].redirectedTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
        <h4 class="small font-weight-bold">{{ 'cancelled' | translate }}
            <span class="float-right">{{ processedCategoryTicketsCounts[selectedCategoryId].cancelledTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-danger" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedCategoryTicketsCounts[selectedCategoryId].cancelledTicketsCount"
                [style.width]="(processedCategoryTicketsCounts[selectedCategoryId].cancelledTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
        <h4 class="small font-weight-bold">{{ 'waiting' | translate }}
            <span class="float-right">{{ processedCategoryTicketsCounts[selectedCategoryId].waitingTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-warning" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedCategoryTicketsCounts[selectedCategoryId].waitingTicketsCount"
                [style.width]="(processedCategoryTicketsCounts[selectedCategoryId].waitingTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
    </div>
    <div *ngIf="!processedCategoryTicketsCounts[selectedCategoryId]">
        {{ 'no-tickets' | translate }}
    </div>
</div>